import type { WebhookLog } from '@/domain/types';
import { requireSupabase } from '@/lib/supabase';

type WebhookRow = {
  id: string;
  provider: string;
  event_type: string;
  order_ref: string | null;
  status: string;
  payload: string;
  created_at: string;
};

function mapWebhook(row: WebhookRow): WebhookLog {
  return {
    id: row.id,
    provider: row.provider,
    eventType: row.event_type,
    orderRef: row.order_ref ?? '',
    status: row.status as 'success' | 'failed',
    payload: typeof row.payload === 'string' ? row.payload : JSON.stringify(row.payload),
    createdAt: row.created_at,
  };
}

export async function listWebhookLogs(): Promise<WebhookLog[]> {
  const supabase = requireSupabase();
  const { data, error } = await supabase
    .from('webhook_logs')
    .select('*')
    .order('created_at', { ascending: false });

  if (error) throw error;
  return ((data as WebhookRow[]) ?? []).map(mapWebhook);
}
